module.exports = __webpack_public_path__ + "img/layanan.68b8b539.png";